export default __webpack_public_path__ + "static/media/Flag_of_Cameroon.6f35aa11.svg";